<template>
    <div class="article">
        <div class="article-area" v-for="(item,index) in cmsArticleData" :key="index">
            <strong>
                <img v-if="item.dataType === 'video'" src="//www1.pcauto.com.cn/zt/gz20190903/video/spicon.png" class="videoicon">
                <em>
                    <a :href="item.url || `//v.pcauto.com.cn/video-${item.id}.html`" @click="contentBp(item)" target="_blank" v-html="item.title"></a>
                </em>						
            </strong>
            <a :href="item.url || `//v.pcauto.com.cn/video-${item.id}.html`" @click="contentBp(item)" class="docLink" target="_blank">
                <div class="doc" v-html="item.summary.substring(0,item.summary.length > 150 ? Math.floor(item.summary.length/2): item.summary.length -1)+'...'"></div>
            </a>
            <div class="paragraphInfo">
                <span><i>分类：</i>{{item.cluster_channel || item.cluster_category}}</span>
                <span v-if="item.author"><i>作者：</i>{{item.author}}</span>
                <span><i>时间：</i>{{ item.pub_date|| item.pub_date_time }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ArticleArea',
        props: {
            cmsArticleData: {
                type: Array,
                default: () => ([])
            }
        },
        methods: {
            contentBp(item) {
                if(item.url) {
                    this.countAd(4243)
                }else {
                    this.countAd(4244)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.article {
    margin-bottom: 25px;
    .article-area {
        margin-top: 25px;
        font-size: 12px;
        strong {
            font-weight: normal;
            font-size: 16px;
            line-height: 32px;
            display: flex;
            align-items: center;
            a {
                font-style: normal;
                text-decoration: underline;
                color: #225599;
            }
            .videoicon {
                width: 18px;
                height: 18px;
                margin-right: 5px;
            }
        }
        ::v-deep em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
        .doc {
            color: #333333;
            line-height: 22px;
            overflow: hidden;
            position: relative;
            cursor: pointer;
        }
        .docLink {
            text-decoration: none;
            display: block;
        }
        .paragraphInfo  {
            margin-top: 5px;
            i {
                color: #777777;
                font-style: normal;
            }
            span {
                width: 120px;
                display: inline-block;
                color: #333333;
                height: 20px;
                overflow: hidden;
                word-break: break-all;
                word-wrap: break-word;
                margin-right: 5px;
            }
        }
    }

}
</style>